import React from 'react';

export default function Home () {
  console.log("Component rendered")
  return(
    <div>
      <h1>Welcome to Cyrene Ministries</h1>
      <div id="about">
        <article>
        <p>Remember, even Jesus needed help carrying his physical cross.  The Bible tells us that “they compelled a passer-by coming from the country, Simon of Cyrene (the father of Alexander and Rufus), to carry His cross.”  Mark 15:21.</p>

        <p>Just like Simon of Cyrene helped Jesus carry his cross, our community is here to help you carry your crosses!  We’ve got your back and we’re here to give you the spiritual lift that you need to be victorious in your battle!</p>

        <p>Just complete a prayer request, and we’ll begin praying for you immediately!</p>
        </article>
      </div>
    </div>
  )
}